<template>
<b-form @submit="onSubmit">
    <b-row class="no-gutters m-3">
        <b-col>
            <h1>{{ecmResourceStrings.ttlECMCrawlerConfiguration}}</h1>
            <p>
                {{ecmResourceStrings.txtJobECM}}
            </p>
        </b-col>
        <b-col class="text-right OTbtnContainer">
            <b-button type="button" variant=" OTSecondary" @click="$router.push({ name: 'jobs'})">{{ecmResourceStrings.lblCancel}}</b-button>
            <b-button type="submit" variant=" OTPrimary" :disabled="$v.$invalid">{{ecmResourceStrings.lblSave}}</b-button>
        </b-col>
    </b-row>
    <template v-if='ecm_repository_type_change==true'>
                <b-row>
                    <b-col cols="12" v-if="repositoryType=='is_generic_v1'">
                        <b-alert class="OTAlert OTAlertInformation" show>
                        <span class="ot-icon-alert-title"></span>
                            {{ecmResourceStrings.infoDefineAnnotationOptions}}
                        </b-alert>
                    </b-col>
                    <b-col cols="12" v-else-if="repositoryType!= 'is_generic_v1'">
                        <b-alert class="OTAlert OTAlertInformation" show>
                        <span class="ot-icon-alert-title"></span>
                            {{ecmResourceStrings.infoConnector}}
                        </b-alert>
                    </b-col>
                </b-row>
            </template>
    <b-row>
        <b-col class="m-3">
            <otif-select
                :label="ecmResourceStrings.lblECMRepository"
                v-model="repositoryId"
                :required="true"
                :values=getrepositories
                :placeholder="ecmResourceStrings.txtJobSelectRepository"
                :description="ecmResourceStrings.txtJobRepositoryDescription"
                @input="changeRepository()"/>
            <otif-select
                :label="ecmResourceStrings.lblPartition"
                v-model="partitionId"
                :required="true"
                :values=getpartitions
                :placeholder="ecmResourceStrings.txtJobSelectPartition"
                :description="ecmResourceStrings.txtJobPartitionDescription"/>
            <otif-select
                :label="ecmResourceStrings.lblConnection"
                v-model="ecmConnectionId"
                :required="true"
                :values=getconnections
                :placeholder="ecmResourceStrings.txtJobSelectConnection"
                :description="ecmResourceStrings.txtJobConnectionDescription"/>
            <otif-select
                :label="ecmResourceStrings.lblRunningContext"
                v-model="engineName"
                :required="true"
                :values="runningcontexts"
                :placeholder="ecmResourceStrings.txtJobSelectRunCtx"
                :description="ecmResourceStrings.txtJobRunCtxDescription"/>
            <otif-select
                :label="ecmResourceStrings.lblOperationType"
                v-model="operationType"
                :required="true"
                :values="operationtypes"
                :placeholder="ecmResourceStrings.txtJobSelectOperationType"
                :description="ecmResourceStrings.txtJobOperTypeDescription"/>
            <otif-textInput
                :label="ecmResourceStrings.lblNumberOfThreads"
                :description="ecmResourceStrings.txtJobNumberOfThreadsDescription"
                :placeholder="ecmResourceStrings.txtJobProvideThreadNum"
                :required="true"
                v-model="numberThreads"
                :invalidMessage="ecmResourceStrings.errJobNumOfThreads"
                :validation="$v.numberThreads"/>
        </b-col>
      
    </b-row>
</b-form>
</template>


<script>

import axios from 'axios';
import { resourceMapper } from '@/utils/resourceMapper.js';
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';

export default {

    mixins: [ validationMixin ],

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            loaded: false,
            ecm_repository_type_change:false,
            form:{
                repositoryId:'',
                operationType:'',
                partitionId:'',
                ecmConnectionId:'',
                engineName:'1',
                numberThreads:1,
            },
            
            ecmrepositories:[],
            ecmpartitions:[],
            ecmconnections:[],
            repositories: [],
            partitions:[],
            connections:[],
            runningcontexts:[{label: '1', value: '1'},{label: '2', value:'2'}],
            operationtypes:[{label: 'Initial Population', value:'InitialPopulation'},
                           {label: 'Synchronization', value:'Synchronization'},
                           {label: 'Synchronization In Loop', value:'SynchronizationInLoop'},
                           {label: 'Persistent Synchronization', value:'PersistentSynchronization'},
                           {label: 'Persistent Synchronization In Loop', value:'PersistentSynchronizationInLoop'}, 
                           ],
        }
    },

    props: ['job'],

    computed: {
        getrepositories: function ()
        {
           this.repositories =[];
           if(this.ecmrepositories)
           {
                var i = 0;
                for(i=0; i<this.ecmrepositories.length;i++)
                {
                    const rep = this.ecmrepositories[i];
                    if(rep)
                    {
                        if(rep.ecmrepositorytype != 'dbms_generic_v1')
                        {
                            this.repositories.push({label: rep.ecmrepositoryname, value:rep.ecmrepositoryid});
                        }
                    }
                }
            }
           return this.repositories;
        },

        getconnections: function ()
        {
            this.connections =[];
            if(this.ecmconnections)
            {
                var i = 0;
                for(i=0; i<this.ecmconnections.length;i++)
                {
                    const con = this.ecmconnections[i];
                    if(this.repositoryId == con.ecmrepositoryid)
                    {
                        this.connections.push({label: con.description, value:con.connectionid});
                        this.repositoryType=con.ecmrepositorytype;
                    }
                }
            }
            return this.connections;
        },

        getpartitions: function ()
        {
           this.partitions =[];
           if(this.ecmpartitions)
           {
                var i = 0;
                for(i=0; i<this.ecmpartitions.length;i++)
                {
                    const part = this.ecmpartitions[i];
                    if(this.repositoryId == part.ecmrepositoryid)
                    {
                        this.partitions.push({label: part.partitiondescription, value:part.partitionid});
                    }
                }
            }
           return this.partitions;
        },
        
        ...resourceMapper([{
            propertyName: 'repositoryId',
            attributeName: 'job_criteria.repositoryId'
        },
        {
            propertyName: 'repositoryType',
            attributeName: 'job_criteria.repositoryType'
        },
        {
            propertyName: 'partitionId',
            attributeName: 'job_criteria.partitionId'
        },
        {
            propertyName: 'ecmConnectionId',
            attributeName: 'job_criteria.ecmConnectionId'
        },
        {
            propertyName: 'operationType',
            attributeName: 'job_criteria.operationType'
        },
        {
            propertyName: 'engineName',
            attributeName: 'job_criteria.engineName'
        },
        {
            propertyName: 'numberThreads',
            attributeName: 'job_criteria.numberThreads'
        },
        {
            propertyName: "annotationOption",
            attributeName: "job_criteria.annotationOption"
        },], 'job', 'ecm-crawler-settings'),
    },

    validations: {
        numberThreads: {
            required,
            minValue: minValue(1)
        },
        repositoryId:{ required },
    },

methods: {

        changeRepository($e)
        {
             this.ecm_repository_type_change=true;
        },

        onSubmit($e) {
            $e.preventDefault();
            var that = this;
            /* default values */
            if(that.job.attributes.job_criteria.repositoryType!='is_generic_v1')
            {
                that.job.set('job_criteria.annotationOption', false);
                var obj = Object.create(null);
                this.job.set('job_criteria.annotationList', obj);
            }
            that.job.set('job_criteria.operationMode', 'Start');
            that.job.set('job_criteria.operationStatus', 'Idle');
            that.job.set('job_criteria.actionStatusCode', '0');
            that.job.set('job_criteria.executionStatusCode', '0');
            that.job.set('job_criteria.actionStatusMessage', '');
            that.job.set('job_criteria.executionFolderPathOrId', '');
            that.job.set('job_criteria.executionComments', '');
            that.job.set('job_criteria.jobId', '');
            this.job.save();
        }
    },

    mounted() {
        var breadcrumbs = [{
            name: 'jobs',
            meta: { label: 'Jobs' }
        },{
            name: 'job-edit',
            meta: { label: this.job.get('job_name') },
            params: { job_id: this.job.id }
        },{
            name: 'ecm-crawler-settings',
            meta: { label: 'ECM Crawler Settings' },
            params: { job_id: this.job.id }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },
  
    created() {
        var that = this;
        const a  = that.job.get('job_criteria.repositoryId');
         this.$snotify.async(this.ecmResourceStrings.txtEcmGetJob, {
                timeout: 0
            });
        axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories')
        .then((res) => {
            this.$snotify.clear();
            if (res.data) {
              //partitions and connections come from repositories
              //ECMRepositoriesStatusListView line 90
                const ecmrepositorylist = res.data.ecmRepository;
                if(ecmrepositorylist)
                {
                    const len = ecmrepositorylist.length;
                    if(len!=0)
                    {
                        for(var k=0; k<len; k++)
                        {
                            const oneecmrepo = ecmrepositorylist[k];
                            if(oneecmrepo)
                            {
                                const ecmrepositoryid = oneecmrepo.repositoryId;
                                const ecmrepositorytype = oneecmrepo.repositoryType;
                                const ecmrepositoryname = oneecmrepo.repositoryName;
                                that.ecmrepositories.push({"ecmrepositoryid":ecmrepositoryid,
                                                            "ecmrepositorytype" : ecmrepositorytype,
                                                            "ecmrepositoryname":ecmrepositoryname});
                                const configurationdatalist = oneecmrepo.configData;
                                if(configurationdatalist)
                                {
                                    const configlen = configurationdatalist.length;
                                    if(configlen!=0)
                                    {
                                        for(var i=0; i<configlen; i++)
                                        {
                                            const oneelement = configurationdatalist[i];
                                            if(oneelement)
                                            {
                                                const paramfullName = oneelement.name;
                                                var connectionID = 0;
                                                var partitionID = 0;//for partitions
                                                var paramName = '';
                                                //parse name to see what we have
                                                //could be one word
                                                //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId, repoExcludedFolder.1.folderPathOrId
                                                const namesArray = paramfullName.split(".");
                                                const lennames = namesArray.length;
                                                if(lennames > 1)
                                                {
                                                    if (namesArray[0] == "repoPartition")
                                                    {
                                                        partitionID = namesArray[1]; 
                                                        paramName = namesArray[2]; 
                                                        var result = that.ecmpartitions.find (e => (e.partitionid == partitionID && e.ecmrepositoryid == ecmrepositoryid ));
                                                        if (result == undefined)
                                                        {
                                                            // not found - add
                                                            that.ecmpartitions.push({
                                                                    "count":that.ecmpartitions.length,
                                                                    "ecmrepositoryid":ecmrepositoryid,
                                                                    "ecmrepositorytype" : ecmrepositorytype,
                                                                    "partitionid" : partitionID,
                                                                    "partitiondescription" : '',
                                                                    "operationType":'',
                                                                    "guioperationType":'',
                                                                    "isRunning":'',
                                                                    "connectionid":'',
                                                                    "connectiondescr":'',});
                                                            //that.getECMRepositoryStatus(ecmrepositoryid, partitionID);
                                                            //get it
                                                            var resultnew = that.ecmpartitions.find (e => e.partitionid == partitionID);
                                                            if (resultnew)
                                                            {
                                                                if(paramName == 'description')
                                                                {
                                                                    resultnew.partitiondescription = oneelement.value;
                                                                }
                                                            }
                                                        }
                                                        else if (result)
                                                        {
                                                            if(paramName == 'description')
                                                            {
                                                                result.partitiondescription = oneelement.value;
                                                            }
                                                        } 
                                                    }
                                                    //connections
                                                    else if (namesArray[0] == "repoParam")
                                                    {
                                                        connectionID = namesArray[1]; 
                                                        paramName = namesArray[2]; 
                                                        var result = that.ecmconnections.find(e => (e.connectionid === connectionID && e.ecmrepositoryid === ecmrepositoryid));
                                                        if (result == undefined)
                                                        {
                                                            // not found - add
                                                            that.ecmconnections.push({
                                                                "count":that.ecmconnections.length,
                                                                "ecmrepositoryid":ecmrepositoryid,
                                                                "ecmrepositorytype" : ecmrepositorytype,
                                                                "connectionid" : connectionID,
                                                                "description":'',
                                                            });
                                                            //get it
                                                            var resultnew = that.ecmconnections.find( e => e.connectionid == connectionID);
                                                            if (resultnew)
                                                            {
                                                                if(paramName == 'description')
                                                                {
                                                                    resultnew.description = oneelement.value;
                                                                }
                                                            }
                                                        }
                                                        else if (result)
                                                        {
                                                            if(paramName == 'description')
                                                            {
                                                                result.description = oneelement.value;
                                                            }
                                                        } 
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    that.loaded = true;
                    that.$v.$reset();
                }
            }
        })
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
            this.$v.$reset();
        });
    },
}

</script>
